//LL: color value can be null, "transparent", color name ("red"), #nnnnnn, rgb(), rgba()
//    and returns "transparent" if AlphaChannel = 0

import * as React from 'react';
import * as _ from 'underscore';
import * as $ from 'jquery';

import { IGlob } from '../../../pdc-platform/src/ts/Glob';
import { IPopupOptions } from '../../../pdc-platform/src/ts/actions/DialogActions';
import RadioGroupFieldComponent from './RadioGroupField';
import { licenseKey } from '../../../_common/libs/dx25/ts/devextreme-license';
import { IValuesCollection } from '../ts/appTheme';

require('dxAll');

declare var DevExpress: any;
declare var Color: any; //LL: for shades, see /libs/bower-components/harthur-color/color-0.7.3-modified.js

//LL: 21.08.18:
//  = true:  use customized DevExpr dxColorBox
//  = false:   create my own "input" color box that calls DevExpr's built-in popup color picker dxColorView
//const USE_STANDARD_COLOR_BOX = false;

//LL: for USE_STANDARD_COLOR_BOX = false
//LL: see IntervalsSelect.tsx  IntervalSelectPopup

type tabID = 'custom' | 'palette' | 'inherited'; //LL: 30.10.19   TRY
type colorFunctionCategory = 'pure' | 'mixed'; //LL: 04.11.19   TRY

interface IColorSelectPopupOptions extends IPopupOptions {
    value;
    editAlphaChannel;
    returnHexadecimal;
    isColorFunction?: boolean; //LL: 04.11.19
    colorFunctionOptions?; //LL: 04.11.19
    colorFunction?; //LL: 31.10.19    if allowInheritedTab
    themeObj?: IValuesCollection;
    onChange(value): void;
}

//LL: 31.10.19: TRY "inherited" Tab   when allowInheritedTab
class InheritedColorContent extends React.Component<any, any> {
    private references: {
        selectBaseColor?: HTMLSelectElement;
        selectBaseOperation?: HTMLSelectElement;
    } = {};

    constructor(props) {
        super(props);

        //colorFunction={ this.props.options.colorFunction }
        //themeObj={ this.props.options.themeObj }
        //   onChange

        let colorFunctionOptions = this.props.colorFunctionOptions;

        let category: colorFunctionCategory = 'pure'; // 'mixed'

        let selectedBaseColor;
        let selectedOperation;
        let colorFunction;
        if (colorFunctionOptions != null) {
            if (colorFunctionOptions.category != null) {
                category = colorFunctionOptions.category;
            }
            selectedBaseColor = colorFunctionOptions.selectedBaseColor;
            selectedOperation = colorFunctionOptions.selectedOperation;
            colorFunction = colorFunctionOptions.colorFunction;
        }

        if (colorFunction == null) {
            colorFunction = this.getPureColorFunction(selectedBaseColor, selectedOperation);
        }

        this.state = {
            category: category,
            //colorFunction: this.props.colorFunction,
            colorFunction: colorFunction,
            //selectedBaseColor: null,  //LL:  or set by this.props
            //selectedOperation: null  //LL:  or set by this.props
            selectedBaseColor: selectedBaseColor, //LL:  or set by this.props
            selectedOperation: selectedOperation
        };
    }

    getPureColorFunction(baseColor, operation) {
        //  ['none', 'darken', 'lighten', 'negate'],
        // 'gray-base' is 'On Surface'

        let functionPure_notset = function (theme) {
            return null;
        };

        let functionPure_none = function (theme) {
            return theme[baseColor];
        };

        //  negate: function() {
        //    for (var i = 0; i < 3; i++) {
        //        rgb[i] = 255 - this.values.rgb[i];
        //    }
        let functionPure_negate = function (theme) {
            return Color(theme[baseColor]).negate().hexString();
        };

        //  darken: function(ratio) {
        //     this.values.hsl[2] -= this.values.hsl[2] * ratio;
        let functionPure_darken = function (theme) {
            return Color(theme[baseColor]).darken(20).hexString();
        };

        //     this.values.hsl[2] += this.values.hsl[2] * ratio;
        let functionPure_lighten = function (theme) {
            return Color(theme[baseColor]).lighten(20).hexString();
        };

        if (baseColor == null) {
            return functionPure_notset;
        }

        switch (operation) {
            case 'none':
                return functionPure_none;
            case 'darken':
                return functionPure_darken;
            case 'lighten':
                return functionPure_lighten;
            case 'negate':
                return functionPure_negate;
            default:
                //LL: here also operation == null
                return functionPure_none;
        }
    }

    handleChange = (value) => {
        if (typeof this.props.onChange === 'function') {
            this.props.onChange(value);
        }
    };

    setStateCallback = () => {
        //let obj: any = _.clone(this.state.value || {});
        let obj: any = _.clone(this.state || {});
        this.handleChange(obj);
    };

    processRadioGroupChange = (val) => {
        console.log('InheritedColorContent processRadioGroupChange val = ' + val);

        //category: colorFunctionCategory = 'pure';  // 'mixed'

        this.setState(
            _.extend(this.state, {
                category: val
            }),
            this.setStateCallback
        );
    };

    processSelectBaseColorChange = (e) => {
        //let val = this.refs.labelPosition.value;
        let elem: any = this.references.selectBaseColor;
        let val = elem.value;
        console.log('processSelectBaseColorChange val = ' + val);

        //let colorFunction = this.getPureColorFunction(this.state.selectedBaseColor, this.state.selectedOperation);
        let colorFunction = this.getPureColorFunction(val, this.state.selectedOperation);

        this.setState(
            _.extend(this.state, {
                selectedBaseColor: val,
                colorFunction: colorFunction
            }),
            this.setStateCallback
        );
    };

    getSelectBaseColor() {
        //LL: see bootstrapTheme:
        //  'gray-base': 'On Surface',  'on-primary': 'On Primary'

        let options = _.map(['gray-base', 'on-primary'], function (val) {
            return (
                <option key={val} value={val}>
                    {val}
                </option>
            );
        });

        //let displayVal = 'gray-base';
        let displayVal = this.state.selectedBaseColor || '';

        if (this.state.selectedBaseColor == null) {
            options.unshift(
                <option key={' '} value={''} disabled={true}>
                    {'choose an item'}
                </option>
            );
        }

        return (
            <select
                ref={(input) => {
                    this.references.selectBaseColor = input;
                }}
                className="form-control selectBaseColor"
                onChange={this.processSelectBaseColorChange}
                value={displayVal}
            >
                {options}
            </select>
        );
    }

    processSelectOperationChange = (e) => {
        //let val = this.refs.labelPosition.value;
        let elem: any = this.references.selectBaseOperation;
        let val = elem.value;
        console.log('processSelectOperationChange val = ' + val);

        let colorFunction = this.getPureColorFunction(this.state.selectedBaseColor, val);

        this.setState(
            _.extend(this.state, {
                selectedOperation: val,
                colorFunction: colorFunction
            }),
            this.setStateCallback
        );
    };

    getSelectOperation() {
        //LL: see Color.js

        // see Utilities.getContrastColor(theme[field]);
        //    const ultimateDark = '#000000';
        //    const ultimateLight = '#FFFFFF';
        //
        //    export function getContrastColor(color) {
        //        if (Color(color).dark()) {
        //            return ultimateLight;
        //        } else {
        //            return ultimateDark;
        //        }
        //    }

        let options = _.map(
            ['none', 'darken', 'lighten', 'negate'], // , 'contrastColor'
            function (val) {
                return (
                    <option key={val} value={val}>
                        {val}
                    </option>
                );
            }
        );

        //let displayVal = this.state.selectedOperation || '';
        let displayVal = this.state.selectedOperation || 'none';

        //LL: no need, 'none' is selected
        //if (this.state.selectedOperation == null) {
        //    options.unshift(
        //        <option
        //            key={ ' ' }
        //            value={ '' }
        //            disabled={ true }
        //        >
        //            { "choose an item" }
        //        </option>
        //    );
        //}

        return (
            <select
                ref={(input) => {
                    this.references.selectBaseOperation = input;
                }}
                className="form-control selectBaseColor"
                onChange={this.processSelectOperationChange}
                value={displayVal}
            >
                {options}
            </select>
        );
    }

    getPureColorsContent() {
        //colorFunction={ this.props.options.colorFunction }
        //themeObj={ this.props.options.themeObj }

        let curColor;
        //let colorFunction = this.props.colorFunction;
        let colorFunction = this.state.colorFunction;
        let themeObj = this.props.themeObj;

        if (themeObj != null && colorFunction != null) {
            curColor = colorFunction(themeObj);
        }

        let colorElem;
        let textElem;

        if (curColor != null) {
            let styleColor: React.CSSProperties = {
                backgroundColor: curColor
            };
            colorElem = <div className="color" style={styleColor}></div>;

            //LL: or title for above
            textElem = <span className="text">{curColor.toString()}</span>;
        }

        let selectBaseColorElement = this.getSelectBaseColor();
        let selectOperationElement = this.getSelectOperation();

        return (
            <div className="inherited-color-content-pure">
                {selectBaseColorElement}
                {selectOperationElement}
                {colorElem}
                {textElem}
            </div>
        );
    }

    getMixedColorsContent() {
        //LL:  "inherited-color-content-mixed"  is not defined yet
        return <div className="inherited-color-content-mixed">{' [Mixed Color Content: to be done ] '}</div>;
    }

    render() {
        let rgItems = [];

        rgItems.push({
            text: 'Pure Colors',
            value: 'pure', // pure,
            content: this.getPureColorsContent()
        });
        rgItems.push({
            text: 'Mixed Colors',
            value: 'mixed', // mixed,
            content: this.getMixedColorsContent()
        });

        return (
            <div className="inherited-color-content">
                <RadioGroupFieldComponent
                    value={this.state.category}
                    options={{
                        name: 'RG_ColorBoxField_Inherited', //LL: needed to differ RadioGroup from other RadioGroups
                        layout: 'vertical',
                        items: rgItems
                    }}
                    onChange={this.processRadioGroupChange}
                />
            </div>
        );
    }
}

export class ColorSelectPopup extends React.Component<
    {
        zIndex: number;
        //LL: value can be null, "transparent", color name, #nnnnnn, rgb(), rgba()
        options: IColorSelectPopupOptions;
        glob: IGlob;

        close(): void;
    },
    {
        value;
        colorFunctionOptions; //LL: 04.11.19
        tab: tabID;
        height: number;
        width: number;
        references: any;
    }
> {
    private materialPalette = {
        Red: [
            '#FFEBEE',
            '#FFCDD2',
            '#EF9A9A',
            '#E57373',
            '#EF5350',
            '#F44336',
            '#E53935',
            '#D32F2F',
            '#C62828',
            '#B71C1C',
            '#FF8A80',
            '#FF5252',
            '#FF1744',
            '#D50000'
        ],
        Pink: [
            '#FCE4EC',
            '#F8BBD0',
            '#F48FB1',
            '#F06292',
            '#EC407A',
            '#E91E63',
            '#D81B60',
            '#C2185B',
            '#AD1457',
            '#880E4F',
            '#FF80AB',
            '#FF4081',
            '#F50057',
            '#C51162'
        ],
        Purple: [
            '#F3E5F5',
            '#E1BEE7',
            '#CE93D8',
            '#BA68C8',
            '#AB47BC',
            '#9C27B0',
            '#8E24AA',
            '#7B1FA2',
            '#6A1B9A',
            '#4A148C',
            '#EA80FC',
            '#E040FB',
            '#D500F9',
            '#AA00FF'
        ],
        DeepPurple: [
            '#EDE7F6',
            '#D1C4E9',
            '#B39DDB',
            '#9575CD',
            '#7E57C2',
            '#673AB7',
            '#5E35B1',
            '#512DA8',
            '#4527A0',
            '#311B92',
            '#B388FF',
            '#7C4DFF',
            '#651FFF',
            '#6200EA'
        ],
        Indigo: [
            '#E8EAF6',
            '#C5CAE9',
            '#9FA8DA',
            '#7986CB',
            '#5C6BC0',
            '#3F51B5',
            '#3949AB',
            '#303F9F',
            '#283593',
            '#1A237E',
            '#8C9EFF',
            '#536DFE',
            '#3D5AFE',
            '#304FFE'
        ],
        Blue: [
            '#E3F2FD',
            '#BBDEFB',
            '#90CAF9',
            '#64B5F6',
            '#42A5F5',
            '#2196F3',
            '#1E88E5',
            '#1976D2',
            '#1565C0',
            '#0D47A1',
            '#82B1FF',
            '#448AFF',
            '#2979FF',
            '#2962FF'
        ],
        LightBlue: [
            '#E1F5FE',
            '#B3E5FC',
            '#81D4FA',
            '#4FC3F7',
            '#29B6F6',
            '#03A9F4',
            '#039BE5',
            '#0288D1',
            '#0277BD',
            '#01579B',
            '#80D8FF',
            '#40C4FF',
            '#00B0FF',
            '#0091EA'
        ],
        Cyan: [
            '#E0F7FA',
            '#B2EBF2',
            '#80DEEA',
            '#4DD0E1',
            '#26C6DA',
            '#00BCD4',
            '#00ACC1',
            '#0097A7',
            '#00838F',
            '#006064',
            '#84FFFF',
            '#18FFFF',
            '#00E5FF',
            '#00B8D4'
        ],
        Teal: [
            '#E0F2F1',
            '#B2DFDB',
            '#80CBC4',
            '#4DB6AC',
            '#26A69A',
            '#009688',
            '#00897B',
            '#00796B',
            '#00695C',
            '#004D40',
            '#A7FFEB',
            '#64FFDA',
            '#1DE9B6',
            '#00BFA5'
        ],
        Green: [
            '#E8F5E9',
            '#C8E6C9',
            '#A5D6A7',
            '#81C784',
            '#66BB6A',
            '#4CAF50',
            '#43A047',
            '#388E3C',
            '#2E7D32',
            '#1B5E20',
            '#B9F6CA',
            '#69F0AE',
            '#00E676',
            '#00C853'
        ],
        LightGreen: [
            '#F1F8E9',
            '#DCEDC8',
            '#C5E1A5',
            '#AED581',
            '#9CCC65',
            '#8BC34A',
            '#7CB342',
            '#689F38',
            '#558B2F',
            '#33691E',
            '#CCFF90',
            '#B2FF59',
            '#76FF03',
            '#64DD17'
        ],
        Lime: [
            '#F9FBE7',
            '#F0F4C3',
            '#E6EE9C',
            '#DCE775',
            '#D4E157',
            '#CDDC39',
            '#C0CA33',
            '#AFB42B',
            '#9E9D24',
            '#827717',
            '#F4FF81',
            '#EEFF41',
            '#C6FF00',
            '#AEEA00'
        ],
        Yellow: [
            '#FFFDE7',
            '#FFF9C4',
            '#FFF59D',
            '#FFF176',
            '#FFEE58',
            '#FFEB3B',
            '#FDD835',
            '#FBC02D',
            '#F9A825',
            '#F57F17',
            '#FFFF8D',
            '#FFFF00',
            '#FFEA00',
            '#FFD600'
        ],
        Amber: [
            '#FFF8E1',
            '#FFECB3',
            '#FFE082',
            '#FFD54F',
            '#FFCA28',
            '#FFC107',
            '#FFB300',
            '#FFA000',
            '#FF8F00',
            '#FF6F00',
            '#FFE57F',
            '#FFD740',
            '#FFC400',
            '#FFAB00'
        ],
        Orange: [
            '#FFF3E0',
            '#FFE0B2',
            '#FFCC80',
            '#FFB74D',
            '#FFA726',
            '#FF9800',
            '#FB8C00',
            '#F57C00',
            '#EF6C00',
            '#E65100',
            '#FFD180',
            '#FFAB40',
            '#FF9100',
            '#FF6D00'
        ],
        DeepOrange: [
            '#FBE9E7',
            '#FFCCBC',
            '#FFAB91',
            '#FF8A65',
            '#FF7043',
            '#FF5722',
            '#F4511E',
            '#E64A19',
            '#D84315',
            '#BF360C',
            '#FF9E80',
            '#FF6E40',
            '#FF3D00',
            '#DD2C00'
        ],
        Brown: [
            '#EFEBE9',
            '#D7CCC8',
            '#BCAAA4',
            '#A1887F',
            '#8D6E63',
            '#795548',
            '#6D4C41',
            '#5D4037',
            '#4E342E',
            '#3E2723'
        ],
        Gray: [
            '#FAFAFA',
            '#F5F5F5',
            '#EEEEEE',
            '#E0E0E0',
            '#BDBDBD',
            '#9E9E9E',
            '#757575',
            '#616161',
            '#424242',
            '#212121'
        ],
        BlueGray: [
            '#ECEFF1',
            '#CFD8DC',
            '#B0BEC5',
            '#90A4AE',
            '#78909C',
            '#607D8B',
            '#546E7A',
            '#455A64',
            '#37474F',
            '#263238'
        ],
        BlackWhite: ['#000000', '#FFFFFF']
    };

    private references: {
        colorSelectContainer?: HTMLDivElement | null;
    } = {};

    constructor(props) {
        const dxLicenseKey = {
            licenseKey: licenseKey
        };

        //dxConfig.default(dxLicenseKey as any);
        DevExpress.config(dxLicenseKey);

        super(props);

        //LL: 31.10.19    colorFunction if allowInheritedTab
        // let allowInheritedTab = (this.props.options.allowInheritedTab === true);
        let curTab: tabID = 'palette';
        //if (this.props.options.colorFunction != null) {
        //    curTab = 'inherited';
        //}
        if (this.props.options.isColorFunction === true) {
            //LL: 04.11.19
            curTab = 'inherited';
        }

        let colorFunctionOptions = this.props.options.colorFunctionOptions || {}; //LL: 04.11.19

        this.state = {
            value: this.props.options.value,
            //tab: 'palette',
            tab: curTab,

            colorFunctionOptions: colorFunctionOptions, //LL: 04.11.19

            height: 538,
            width: 468,

            references: {}
        };
    }

    static top = 0;
    static left = 0;

    private handleDragStop = (e, ui) => {
        const dialog = this.state.references.popoverContent;
        ColorSelectPopup.top = dialog.offsetTop;
        ColorSelectPopup.left = dialog.offsetLeft;
    };

    componentDidMount() {
        const dialog = this.state.references.popoverContent;

        $(dialog).draggable({
            handle: '.popover-header',
            stop: this.handleDragStop
        });

        this.setState({
            height: dialog.clientHeight,
            width: dialog.clientWidth
        });

        this.setColorView(this.state.value);
    }

    componentWillUnmount() {
        const dialog = this.state.references.popoverContent;

        $(dialog).draggable('destroy');
    }

    componentDidUpdate(prevProps, prevState) {
        this.setColorView(this.state.value);
    }

    shouldComponentUpdate(nextProps, nextState) {
        if (
            nextState.value != null &&
            this.state.value != null &&
            nextState.value.toUpperCase() === this.state.value.toUpperCase() &&
            nextState.tab === this.state.tab
        ) {
            return false;
        } else {
            return true;
        }
    }

    setColorView(value: any) {
        //LL: value can be null, "transparent", color name, #nnnnnn, rgb(), rgba()

        let colorSelectContainer: any = this.references.colorSelectContainer;
        let colorSelectContainerJQ: any = $(colorSelectContainer);

        colorSelectContainerJQ.dxColorView({
            editAlphaChannel: this.props.options.editAlphaChannel, //false, //true,
            applyValueMode: 'instantly', //LL: this must be set - to get CC.option("value"); Default Value: 'useButtons'
            value: value,
            onValueChanged: this.handleColorChange
        });
    }

    handleColorChange = (e) => {
        this.setState({
            value: e.value
        });
    };

    containerClick = (e) => {
        //LL: 07.11.19: needed:
        e.stopPropagation();
        e.preventDefault();
    };

    handleKeyDown = (e) => {
        switch (e.code) {
            case 'Enter': // e.key = "Enter"
                e.stopPropagation();
                e.preventDefault();

                this.applyButtonHandler();
                break;

            case 'Escape': // e.key = "Escape"
                e.stopPropagation();
                e.preventDefault();

                this.cancelButtonHandler();
                break;
        }
    };

    applyButtonHandler = (e?) => {
        //LL: 07.11.19: needed:
        if (e != null) {
            e.stopPropagation();
            e.preventDefault();
        }

        //LL: 30.10.19: TRY "inherited" Tab
        if (this.state.tab === 'inherited') {
            //LL: return not color value, but function

            //   TEMP:
            //  NO_NO: let theme = this.props.options.themeObj;
            let functionPure = function (theme) {
                return theme['gray-base']; //LL: it is 'On Surface'
            };
            let val: any = functionPure;

            //LL: 05.11.19:
            let colorFunctionOptions = this.state.colorFunctionOptions;
            if (colorFunctionOptions != null) {
                val = colorFunctionOptions.colorFunction;
            }

            //LL: also save colorFunctionOptions:

            if (typeof this.props.options.onChange === 'function') {
                this.props.options.onChange(val);
            }

            this.props.close();

            return;
        }

        let colorSelectContainer: any = this.references.colorSelectContainer;
        let colorSelectContainerJQ: any = $(colorSelectContainer);

        let CV = colorSelectContainerJQ.dxColorView('instance');

        let val = CV.option('value');

        let curColor = CV._currentColor;

        if (curColor != null && curColor.a === 0) {
            val = 'transparent';
        } else if (this.props.options.returnHexadecimal === true) {
            val = Color({
                r: curColor.r,
                g: curColor.g,
                b: curColor.b
            }).hexString();
            //LL: sometimes only "#rrggbb" is possible, (or pure "transparent") - in GISMapField.tsx
        }

        if (typeof this.props.options.onChange === 'function') {
            this.props.options.onChange(val);
        }

        this.props.close();
    };

    cancelButtonHandler = (e?) => {
        //LL: 07.11.19: needed:
        if (e != null) {
            e.stopPropagation();
            e.preventDefault();
        }

        this.props.close();
    };

    private getContent = () => {
        const palette = this.getPalette();

        //let allowInheritedTab = this.props.options.allowInheritedTab === true;

        //let liInherited;
        //let contentInherited;

        // if (allowInheritedTab) {
        //     liInherited = (
        //         <li className="nav-item">
        //             <a
        //                 className={'nav-link ' + (this.state.tab === 'inherited' ? 'active' : '')}
        //                 href="#"
        //                 onClick={(e) => this.handleTabClick(e, 'inherited')}
        //             >
        //                 {'Inherited'}
        //             </a>
        //         </li>
        //     );

        //     const inheritedContentElem = this.getInheritedContentElem();

        //     contentInherited = (
        //         <div className={'p-1 ' + (this.state.tab === 'inherited' ? '' : 'hidden')}>{inheritedContentElem}</div>
        //     );
        // }

        return (
            <div>
                <ul className="nav nav-tabs">
                    <li className="nav-item">
                        <a
                            className={'nav-link ' + (this.state.tab === 'palette' ? 'active' : '')}
                            href="#"
                            onClick={(e) => this.handleTabClick(e, 'palette')}
                        >
                            {'Palette'}
                        </a>
                    </li>
                    <li className="nav-item">
                        <a
                            className={'nav-link ' + (this.state.tab === 'custom' ? 'active' : '')}
                            href="#"
                            onClick={(e) => this.handleTabClick(e, 'custom')}
                        >
                            {'Custom'}
                        </a>
                    </li>
                    {/* {liInherited} */}
                </ul>

                <div
                    id="color"
                    ref={(input: HTMLDivElement | null) => {
                        this.references.colorSelectContainer = input;
                    }}
                    className={'p-1 ' + (this.state.tab === 'custom' ? '' : 'hidden')}
                ></div>

                <div className={'p-1 ' + (this.state.tab === 'palette' ? '' : 'hidden')}>{palette}</div>

                {/* {contentInherited} */}
            </div>
        );
    };

    private handleTabClick = (e, tab: tabID) => {
        e.stopPropagation();
        e.preventDefault();
        this.setState({
            tab: tab
        });
    };

    // //LL: 04.11.19: TRY "inherited" Tab
    // processInheritedContentChange = (val) => {
    //     console.log('!!! processInheritedContentChange val = ' + val);
    //     this.setState({
    //         colorFunctionOptions: val
    //     });
    // };
    // //LL: 31.10.19: TRY "inherited" Tab
    // private getInheritedContentElem = () => {
    //     return (
    //         <InheritedColorContent
    //             colorFunction={this.props.options.colorFunction}
    //             colorFunctionOptions={this.state.colorFunctionOptions}
    //             themeObj={this.props.options.themeObj}
    //             onChange={this.processInheritedContentChange}
    //         />
    //     );
    // };

    //LL:   OE func
    private getPalette = () => {
        let nearest = this.nearestPaletteColor(this.state.value); //LL: value can be null !

        return _.map(_.keys(this.materialPalette), (key) => {
            let colorRow = this.getColorRow(this.materialPalette[key], nearest);
            return (
                <div key={key} className="d-flex flex-row w-100 mb-1">
                    {colorRow}
                </div>
            );
        });
    };

    //LL:   OE func
    private getColorRow = (colors, nearest) => {
        return _.map(colors, (color: string) => {
            let content;
            if (color.toUpperCase() === nearest.toUpperCase()) {
                content = <span className="fa fa-circle"></span>;
            }

            let textColor = '#000000';
            if (Color(color).dark()) {
                textColor = '#FFFFFF';
            }

            return (
                <div
                    key={'color-' + color}
                    className="flex-fill"
                    style={{
                        backgroundColor: color,
                        color: textColor,
                        minWidth: '0.5rem',
                        minHeight: '1rem',
                        textAlign: 'center'
                    }}
                    title={color}
                    onClick={(e) => this.handlePaletteClick(e, color)}
                >
                    {content}
                </div>
            );
        });
    };

    //LL:   OE func    //LL: colorCheck can be null !
    private nearestPaletteColor(colorCheck) {
        let curDistance = 1000; // the max possible is sqrt(255*255 + 255*255 + 255*255) (~ 442)
        let nearest = '#FFFFFF';

        //LL: colorCheck can be null !
        if (colorCheck != null) {
            _.each(_.keys(this.materialPalette), (key) => {
                _.each(this.materialPalette[key], (color: string) => {
                    let dist = this.colorDistance(colorCheck, color);
                    if (dist <= curDistance) {
                        curDistance = dist;
                        nearest = color;
                    }
                });
            });
        }

        return nearest;
    }

    //LL:   OE func
    private colorDistance(c1, c2) {
        let rgb1 = Color(c1).rgbArray();
        let rgb2 = Color(c2).rgbArray();
        return Math.sqrt(
            Math.pow(rgb1[0] - rgb2[0], 2) + Math.pow(rgb1[1] - rgb2[1], 2) + Math.pow(rgb1[2] - rgb2[2], 2)
        );
    }

    private handlePaletteClick(e, color) {
        //LL: 07.11.19: needed:
        e.stopPropagation();
        e.preventDefault();

        this.setState({
            value: color
        });
    }

    render() {
        let style: any = {
            display: 'block',
            left: ColorSelectPopup.left,
            top: ColorSelectPopup.top,
            zIndex: this.props.zIndex
        };

        let popupTitle = 'Color Select';

        let content = this.getContent();

        return (
            <div className={'color-select-popup'} onKeyDown={this.handleKeyDown}>
                <div
                    className={'popover ui-draggable color-select-popover'}
                    style={style}
                    onClick={this.containerClick}
                    onKeyDown={this.handleKeyDown}
                    ref={(input) => {
                        this.state.references.popoverContent = input;
                    }}
                >
                    <h3 className="popover-header">
                        {popupTitle}
                        <button
                            type="button"
                            className="close"
                            title="Cancel all changes"
                            onClick={this.cancelButtonHandler}
                        >
                            ×
                        </button>
                    </h3>
                    <div className="popover-body">{content}</div>
                    <div className="modal-footer">
                        <button className="btn btn-success" onClick={this.applyButtonHandler}>
                            {'OK'}
                        </button>
                        <button className="btn btn-default" onClick={this.cancelButtonHandler}>
                            {'Cancel'}
                        </button>
                    </div>
                </div>
            </div>
        );
    }
}

export interface IColorBoxFieldProperties {
    value?: any;
    param?: any;
    title?: string;
    themeObj?: IValuesCollection;
    disabled?: boolean; //   def false
    readOnly?: boolean; //   def false
    showText?: boolean; //   def true
    maxColorWidth?: string; // as "15px", //"1rem",  //LL: 11.09.18
    //LL:   OLD: and New:
    hideTransparency?: boolean; // def false, as in old ColorField     ! DevExpr: editAlphaChannel
    //LL: sometimes only "#rrggbb" is possible, (or pure "transparent") - in GISMapField.tsx
    returnHexadecimal?: boolean; // def false, intersting only if hideTransparency = false

    //LL: when called by .ts
    options?: {
        title?: string;
        disabled?: boolean; //   def false
        readOnly?: boolean; //   def false
        showText?: boolean; //   def true
        hideTransparency?: boolean; // def false, as in old ColorField
        //LL: sometimes only "#rrggbb" is possible, (or pure "transparent") - in GISMapField.tsx
        returnHexadecimal?: boolean; // def false, intersting only if hideTransparency = false
        maxColorWidth?: string; // as "15px", //"1rem",  //LL: 11.09.18
    };
    glob: IGlob;

    onChange?(value: any): void;
}

export class ColorBoxField extends React.Component<
    IColorBoxFieldProperties,
    {
        editing: boolean;
    }
> {
    //LL: sometimes only "#rrggbb" is possible, (or pure "transparent")   // def false
    getReturnHexadecimal = (props: IColorBoxFieldProperties) => {
        let returnHexadecimal = props.options != null ? props.options.returnHexadecimal : props.returnHexadecimal;

        if (returnHexadecimal == null) {
            returnHexadecimal = false; // default
        }
        return returnHexadecimal;
    };

    getDisabled = (props: IColorBoxFieldProperties) => {
        let disabled = props.options != null ? props.options.disabled : props.disabled;
        if (disabled == null) {
            disabled = false;
        }
        return disabled;
    };

    getReadOnly = (props: IColorBoxFieldProperties) => {
        let readOnly = props.options != null ? props.options.readOnly : props.readOnly;
        if (readOnly == null) {
            readOnly = false;
        }
        return readOnly;
    };

    getShowText = (props: IColorBoxFieldProperties) => {
        let showText =
            props.options != null && props.options.showText != null ? props.options.showText : props.showText;

        if (showText == null) {
            showText = true;
        }

        return showText;
    };

    getMaxColorWidth = (props: IColorBoxFieldProperties) => {
        let maxColorWidth = props.options != null ? props.options.maxColorWidth : props.maxColorWidth;

        return maxColorWidth; // may be null
    };

    getUseAlphaChannel = (props: IColorBoxFieldProperties) => {
        let useAlphaChannel = true;
        let hideTransparency = props.options != null ? props.options.hideTransparency : props.hideTransparency;

        if (hideTransparency != null) {
            useAlphaChannel = !hideTransparency;
        }

        return useAlphaChannel;
    };

    private references: {
        container?: HTMLDivElement;
        canvas?: HTMLCanvasElement;
    } = {};

    constructor(props) {
        super(props);

        this.state = {
            editing: false
        };
    }

    componentDidMount() {
        let value = this.props.value;

        this.drawNotSetBox(value);
        this.drawTransparentBox(value);
    }

    componentDidUpdate(prevProps, prevState) {
        let value = this.props.value;

        this.drawNotSetBox(value);
        this.drawTransparentBox(value);
    }

    getContainer() {
        return $(this.references.container);
    }

    handleChangeColor = (value) => {
        if (typeof this.props.onChange === 'function') {
            this.props.onChange(value);
        }
    };

    handleClose = () => {
        this.setState(
            _.extend(this.state, {
                editing: false
            })
        );
    };

    handleOnColorClick = (e) => {
        e.stopPropagation();
        e.preventDefault();

        let disabled = this.getDisabled(this.props);
        let readOnly = this.getReadOnly(this.props);

        if (disabled || readOnly) {
            return;
        }

        let useAlphaChannel = this.getUseAlphaChannel(this.props);
        let returnHexadecimal = this.getReturnHexadecimal(this.props);
        let value = this.props.value;
        let colorFunction;
        let isColorFunction = typeof value === 'function';

        if (isColorFunction) {
            colorFunction = value;

            if (this.props.themeObj != null) {
                value = value(this.props.themeObj);
            } else {
                value = '#000000'; // null;
            }
        }

        this.props.glob.DialogActions.createPopup<IColorSelectPopupOptions>('custom', {
            top: 0,
            left: 0, //LL: window left top - my preference
            value: value,
            editAlphaChannel: useAlphaChannel,
            returnHexadecimal: returnHexadecimal,
            isColorFunction: isColorFunction, //LL: 04.11.19
            colorFunction: colorFunction,
            themeObj: this.props.themeObj,
            close: this.handleClose, //LL: 08.11.19  to change state.editing
            onChange: this.handleChangeColor,

            component: ColorSelectPopup
        });

        this.setState(
            _.extend(this.state, {
                editing: true
            })
        );
    };

    // handleClearValue = (e) => {
    //     let val = this.getDefault();
    //     e.stopPropagation();
    //     e.preventDefault();
    //     if (typeof this.props.onChange === 'function') {
    //         this.props.onChange(val);
    //     }
    // }

    private getDefault() {
        let args = Array.prototype.slice.call(arguments, 0);

        if (this.props.param != null) {
            if (typeof this.props.param.defaultVal === 'function') {
                try {
                    return this.props.param.defaultVal.apply(this, args);
                } catch (e) {
                    return;
                }
            } else {
                return this.props.param.defaultVal;
            }
        } else {
            return null;
        }
    }

    drawNotSetBox(value: any) {
        if (value == null) {
            let canvasValid = true;
            const container = this.getContainer();
            const contW = container.width();
            const contH = container.height();

            let canvas = this.references.canvas;

            if (canvas == null) {
                console.log('value == null, but canvas not found');
                return;
            }

            if (canvas.getContext('2d') == null) {
                console.log('OOps! canvas is invalid object!');
                canvasValid = false;
            }

            if (canvas && canvasValid == true && canvas.getContext('2d')) {
                //VR for JEST testing
                let context = canvas.getContext('2d');
                let W = canvas.width;
                let H = canvas.height;

                canvas.width = contW;
                W = canvas.width;
                canvas.height = contH;
                H = canvas.height;

                context.fillStyle = 'white'; // "yellow";
                context.fillRect(0, 0, W, H);

                context.strokeStyle = '#cccccc'; // "blue";
                context.lineWidth = 0.5; // 1;

                context.moveTo(0, 0);
                context.lineTo(W, H);
                context.stroke(); //  make the line visibile with the stroke color

                context.moveTo(0, H);
                context.lineTo(W, 0);
                context.stroke(); //  make the line visibile with the stroke color
            }
        }
    }

    drawTransparentBox(value: any) {
        if (value === 'transparent') {
            const container = this.getContainer();
            const contW = container.width();
            const contH = container.height();
            const canvas = this.references.canvas;

            if (canvas == null) {
                console.log('value == null, but canvas not found');
                return;
            }

            if (canvas && canvas.getContext('2d')) {
                //VR for JEST testing
                let context = canvas.getContext('2d');
                let W = canvas.width;
                let H = canvas.height;

                canvas.width = contW;
                W = canvas.width;
                canvas.height = contH;
                H = canvas.height;

                context.fillStyle = 'yellow'; // try

                //LL: ====== create pattern:  see Gantt/PatternManager.ts ===============

                let color1 = 'white'; //  or "#fafafa"
                let color2 = '#cccccc';

                //  == getPatternCanvas(pattern, color1, color2), for pattern = 'Checkered' or 'CheckeredWide'
                let patternCanvas: HTMLCanvasElement = null;

                let contextSize = 14;
                let rectSize = 7;

                //  in Gantt:
                //    patternCanvas = PatternsManager.createPatternCanvas(contextSize);
                //    PatternsManager.createPattern_Canvas_checkeredSmall(patternCanvas, color1, color2);

                //   == in createPatternCanvas:
                patternCanvas = document.createElement('canvas');
                patternCanvas.width = contextSize;
                patternCanvas.height = contextSize;

                //  == in createPattern_Canvas_checkered(patternCanvas, color1, color2, rectSize):
                let pctx = patternCanvas.getContext('2d');
                //     rect: l,t,w,h
                let patternSize = rectSize * 2; //  actually = contextSize
                pctx.fillStyle = color1;
                pctx.fillRect(0, 0, patternSize, patternSize);
                pctx.fillStyle = color2;
                pctx.fillRect(0, 0, rectSize, rectSize);
                pctx.fillRect(rectSize, rectSize, rectSize, rectSize);

                //  == after getPatternCanvas:
                //  -- actual draw:
                let patternFill = context.createPattern(patternCanvas, 'repeat');
                context.fillStyle = patternFill;

                context.fillRect(0, 0, W, H);

                //PatternsManager.deletePatternCanvas(id);
                if (patternCanvas != null) {
                    patternCanvas.remove();
                }
                //  == in deletePatternCanvas(id):
                //    let elem = $(id);
                //    elem.find("canvas#pattern").remove();
            }
        }
    }

    render() {
        let color = this.props.value;

        //let defaultColor = this.getDefault(); //LL: 20.09.18: use these when value == null (set it in main)

        if (color == null) {
            color = this.getDefault(); //defaultColor;
        }

        let isColorFunction = typeof color === 'function';

        if (isColorFunction) {
            if (this.props.themeObj != null) {
                color = color(this.props.themeObj);
            } else {
                color = null;
            }
        }

        let text = _.isObject(color) ? color.hexString() : color;

        //LL: when null, draw rect with Andrew flag.
        let notSetElem = null;

        if (color == null) {
            text = 'not set';
            notSetElem = (
                <canvas
                    ref={(input) => {
                        this.references.canvas = input;
                    }}
                    key="not-set-canvas"
                    className="color-notset"
                />
            );
        }

        //LL: when "transparent", draw rect with special canvas pattern
        let transparentElem = null;
        if (color === 'transparent') {
            //  className="color-notset"  will do
            //  for "not set"
            transparentElem = (
                <canvas
                    ref={(input) => {
                        this.references.canvas = input;
                    }}
                    key="transparent-canvas"
                    className="color-notset"
                />
            );
        }

        let showText = this.getShowText(this.props); // color text after color rectangle
        //let minBoxWidth = 15;  // css  minWidth
        let colorText;
        if (showText) {
            colorText = (
                <span key="spanText" className="color-text">
                    {text}
                </span>
            );
        }

        let style2: any = {
            backgroundColor: color
        };

        let maxColorWidth = this.getMaxColorWidth(this.props);
        if (maxColorWidth != null) {
            style2.maxWidth = maxColorWidth;
        }

        //LL: 07.05.19: title as color was destroyed by OE
        let title = this.props.options != null ? this.props.options.title : this.props.title;

        if (title == null || title === '') {
            if (!showText) {
                title = text;
            }
        }

        //LL: 31.10.19:
        let inheritedElem;

        if (isColorFunction) {
            inheritedElem = (
                <span
                    className="glyphicon glyphicon-arrow-down color-inherited"
                    title={'Inherited from Base Color'}
                ></span>
            );
        }

        //LL: 08.11.19
        let editing = this.state.editing;
        let style1: any = {};

        if (editing === true) {
            //style1.border = "1px solid blue";
            let borderColor = '#01579b';
            let themeObj = this.props.themeObj;
            let borderColorThemeName = 'colorbox-editing-border'; //LL: in bootstrapTheme.ts
            if (themeObj != null && themeObj[borderColorThemeName] != null) {
                borderColor = themeObj[borderColorThemeName];
            }
            style1.border = '1px solid ' + borderColor;
        }

        return (
            <div className="form-control colorbox-field" style={style1} onClick={this.handleOnColorClick} title={title}>
                {inheritedElem}
                <div
                    key="color-container"
                    style={style2}
                    className="color-container"
                    ref={(input) => {
                        this.references.container = input;
                    }}
                >
                    {notSetElem}
                    {transparentElem}
                </div>
                {colorText}
            </div>
        );
    }
}
